import React from 'react'
import {Alert, Typography} from '@mui/material'

export function Help() {
  return (
    <>
      <Typography variant="h3" sx={{mt: 3}}>
        Known Gaps
      </Typography>
      <Typography variant="body1" component="div">
        <ul style={{marginLeft: -20}}>
          <li>sticky filtering of fotos by tag</li>
          <li>upload fotos from urls</li>
          <li>support for points of interest & posts (ie optional image & geo data)</li>
          <li>better offline & geotracking story so can do things like locate points of interest (eg water holes)</li>
          <li>printer-friendly so trips can be saved as pdf's</li>
          <li>
            better integration with cloud providers such as apple & google to avoid having to download to your device and then upload to fotolog
          </li>
          <li>embedding of videos from places like youtube & vimeo</li>
          <li>basic foto editing support: crop, rotate, filter</li>
          <li>allow others to rate points of interest</li>
          <li>support comments</li>
          <li>draw routes on map</li>
          <li>cluster map markers when there are too many in one location</li>
          <li>custom domain name ala TravelMap</li>
          <li>personalize timestamps</li>
        </ul>
      </Typography>
    </>
  )
}

export function About() {
  return (
    <>
      <Alert icon={false} severity="warning">
        <Typography variant="h3" sx={{my: 3, textTransform: 'uppercase'}} color="error">
          WARNING: Code Level Beta
        </Typography>
        <Typography variant="body1" sx={{my: 3}}>
          Thank you so much for checking this out!  Please share with me any ideas & critiques. Since this is beta software, do not depend on it for anything critical such as backing up of important fotos.
        </Typography>
      </Alert>
      <Typography variant="h3" sx={{mt: 3, mb: 1}}>
        Intro
      </Typography>
      <Typography variant="body1">
        I built this application to scratch some personal itches that I had while journaling my travels and trying to share with friends & family. Account creation is invitation-only - send me an email if you would like one. Don't upload any images that you are not comfortable with me seeing since I may need to when trouble-shooting issues.
      </Typography>
      <Typography variant="h3" sx={{mt: 3, mb: 1}}>
        Project Longevity
      </Typography>
      <Typography variant="body1">
        I plan to give away the source code with instructions for self-hosting and continue hosting a personal instance for friends & family. If you happen to be looking for a more robust & well-supported solution, I recommend <a href="https://travelmap.net">TravelMap</a> or <a href="https://polarsteps.com">PolarSteps</a> which share a lot with what I'm trying to do here.
      </Typography>
      <Help/>
    </>
  )
}
